import { Text } from "@merge-api/merge-javascript-shared";

const HEADERS = ["Created", "User", "Status", "Comment", ""];

export function BlueprintVersionHistoryTableHead() {
  return (
    <thead className="border-b border-gray-10">
      <tr>
        {HEADERS.map((header) => (
          <th key={header} className="px-6 py-3 text-left">
            <Text variant="h6">{header}</Text>
          </th>
        ))}
      </tr>
    </thead>
  );
}
